import httpRequest from "@/services/httpRequest"

export default ({
  namespaced: true,
  state: {
    isLoading: false,
    newsData: null,
    newsItem: {}
  },
  mutations: {
    SET_IS_LOADING(state, data) {
      state.isLoading = data
    },
    SET_NEWS_DATA(state, data) { // replace data
      state.newsData = data
    },
    APPEND_NEWS_DATA(state, data) {
      if (state.newsData && Array.isArray(state.newsData)) {
        state.newsData = [...state.newsData, ...data]  // append
      } else {
        state.newsData = data
      }
    },
    RESET_NEWS_DATA(state) {
      state.newsData = null
    },
    SET_NEWS_ITEM(state, data) {
      state.newsItem = data
    },
  },
  actions: {
    async getNews({ rootState, commit }, { params, append = false }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/news`,
          method: 'GET',
          params: params
        },
        authorized: true
      }
      const res = await httpRequest(payload)
      if (res.status === 200) {
        if (append) {
          commit('APPEND_NEWS_DATA', res.data.results)
        } else {
          commit('SET_NEWS_DATA', res.data.results)
        }
        return res.data.results
      }
      return []
    },
  }
})
